<template>
  <footer class="footer">
    <!-- Main Footer Content -->
    <div class="footer-main">
      <div class="container">
        <div class="footer-content">
          
          <!-- Brand Section -->
          <div class="footer-brand">
            <div class="footer-logo">
              <img src="@/assets/img/travipet_logo_horizontal_fondo_oscuro.png" alt="TraviPet Logo" class="logo-img">
            </div>
            <p class="footer-description">
              Somos gente que ama a los animales, los transportamos donde y cuando lo necesites.
            </p>
            <div class="footer-social">
              <a href="#" target="_blank" title="Facebook" class="social-link">
                <i class="fab fa-facebook"></i>
              </a>
              <a href="#" target="_blank" title="Instagram" class="social-link">
                <i class="fab fa-instagram"></i>
              </a>
              <a href="#" target="_blank" title="WhatsApp" class="social-link">
                <i class="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>

          <!-- Links Sections -->
          <div class="footer-links">
            
            <!-- Services Section -->
            <div class="footer-section">
              <h3 class="footer-title">Servicios</h3>
              <ul class="footer-list">
                <li><a href="/howto" class="footer-link">¿Cómo usar nuestros servicios?</a></li>
                <li><a href="/" class="footer-link">Preguntas Frecuentes</a></li>
                <li><a href="/" class="footer-link">Cómo ser un Conductor</a></li>
              </ul>
            </div>

            <!-- Legal Section -->
            <div class="footer-section">
              <h3 class="footer-title">Legal</h3>
              <ul class="footer-list">
                <li><a href="/terms" class="footer-link">Términos y Condiciones</a></li>
                <li><a href="/privacy" class="footer-link">Política de Privacidad</a></li>
                <li><a href="/" class="footer-link">Contacto</a></li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="container">
        <div class="footer-bottom-content">
          <div class="footer-copyright">
            <p>&copy; 2024 TraviPet. Todos los derechos reservados.</p>
          </div>
          <div class="footer-badges">
            <span class="badge">Seguro</span>
            <span class="badge">Confiable</span>
            <span class="badge">24/7</span>
          </div>
        </div>
      </div>
    </div>

  </footer>
</template>

<script>
export default {
    name:'Footer'
}
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';
</style>